export default __webpack_public_path__ + "static/media/menCoat.eb80ac08.svg";